var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPauseAudioSample = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#0C1B2A"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M17 10h3v10h-3zM10 10h3v10h-3z"
})));
export default SvgPauseAudioSample;